import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
const REACT_APP_TRANSLATE = process.env.REACT_APP_TRANSLATE || '';

const { language } = window.navigator;

const resources = {
    en: {
        translation: {
            confirming_email: 'We are verifying your account. Make sure to set up a password once your email is confirmed.',
            email_not_confirmed: 'We could not confirm your account. ',
            check_location_settings: 'Please check your location settings',
            confirm_button_text: 'Confirm',
            confirm_email_info_text: 'Please, set up a password for your Geozilla account',
            confirm_email_success_message: 'Congrats, {name}! Your Geozilla account has been set up! Enjoy :)',
            error_page_info_text: 'Something went wrong. Please contact us at {support_email}',
            error_page_title: 'Oops',
            frontend_confirm_password_input_placeholder: 'Confirm Password',
            frontend_download_geozilla_button_text: 'Download Geozilla',
            geozilla_main_title: 'Geozilla - Friends & Family Locator',
            get_via_sms_form_header: 'Send me app link by text:',
            get_via_sms_info_text: 'Help your friend get rewarded with Premium account in Geozilla:open this link on your cell phone, install and register in Geozilla',
            get_via_sms_send_link_button_text: 'Send Link',
            get_via_sms_successful_sent: 'The link was sent! Check your phone!',
            incorrect_number_format: 'Incorrect phone number format',
            invitation_expired_download_app_link_text: 'Tap the button to download the app.',
            invitation_expired_post_title: 'The Invitation has expired.',
            invitation_og_desc: '(click on your phone)',
            invitation_og_title: 'Let\'s keep each other safe! Join me in Geozilla safety assistant - mobile app. We can look out for each other and send emergency alerts if in trouble.',
            invitation_send_sms_with_link_title: 'Enter your phone number to receive an SMS with a download link.',
            invitation_user_invites_you_message: '{sender_name} invites you to a free Geozilla group.',
            invitation_why_text: 'Why? So you can check where your loved ones are in real-time and send Emergency Alerts if in trouble.',
            open_geozilla_app_link_text: 'Open Geozilla App',
            open_invite_link_text: 'Open Invite',
            open_this_link_on_smartphone: 'Open this link from your smartphone',
            password_field_placeholder: 'Password',
            password_too_short_error: 'Oops! Password must contain at least 8 symbols.',
            passwords_fields_not_match: 'The password fields do not match.',
            reset_password_info_text: 'Please, enter a new password for your Geozilla account',
            reset_password_success_text: 'New password was successfully set!',
            send_sms_btn_text: 'Send Text',
            server_problems_error: 'There are some problems. Please try again later!'
        },
    }
};

i18n
    .use(BackendAdapter)
    .use(initReactI18next)
    .init({
        lng: language,
        fallbackLng: 'en',
        backend: {
            backend: XHR,
            backendOption: {
                allowMultiLoading: true,
                loadPath: REACT_APP_TRANSLATE,
                parse: (res) => {
                    const { data } = JSON.parse(res);
                    Object.assign(resources, data);
                    return resources;
                },
            }
        }
    });


export default i18n;

